export default {
  install: (vue) => {
    vue.component('Toback', resolve => require(['@/components/ToBack/index'], resolve))
  }
}
